import { Spinner, Stack } from "@servicetitan/design-system"


export const LoadingFallback = () => {
    return (
        <Stack className="w-100" justifyContent="center" alignItems="center">
            <Stack.Item>
                <Spinner size="large" />
            </Stack.Item>
        </Stack>
    )
}